<template>
  <div>
    <page-header title="Типы грузоперевозок по России" title-in-breadcrumbs="Типы перевозок"/>
    <div id="about" v-if="shippingTypesContent" class="public-container public-container-mobile shipping-types-page-wrapper">
      <h2 class="vz-text-align-left">{{ shippingTypesContent?.blocks?.about?.title }}</h2>
      <p>{{ shippingTypesContent?.blocks?.about?.description }}</p>
      <div class="shipping-types-page">
        <div
          v-for="item of shippingTypesItems"
          :key="item.id"
          :id="item.id"
        >
          <h2 class="shipping-types-page-item-title">
            <vz-icon
              v-bind="item.icon"
              class="mr-15"
              variant="primary"
              no-masked-icon
              size="34"
            />
            <div>{{ item?.title }}</div>
          </h2>
          <public-service-links-grid :items="item.links" text-only />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { PublicInfoGridItem } from '~/types/public'
import { useShippingTypesStore } from '~/stores/shipping-types'
import PageHeader from '~/components/public/page-header.vue'
import PublicServiceLinksGrid from '~/components/public/public-service-links-grid.vue'
import {until} from '@vueuse/core';

const { shippingTypesContent, shippingTypesItems } = storeToRefs(useShippingTypesStore())

await until(() => shippingTypesItems.value?.length).toBeTruthy()
</script>

<style scoped lang="scss">
.shipping-types-page {
  display: flex;
  flex-direction: column;
  gap: 110px;
  margin-top: 110px;

  &-wrapper {
    margin-top: 70px;
    margin-bottom: 70px;
  }

  &-item-title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 28px;
    margin-bottom: 30px;
  }

  @media screen and (max-width: $pub-md) {
    gap: 90px;
    margin-top: 90px;
  }

  @media screen and (max-width: $pub-sm) {
    gap: 75px;
    margin-top: 75px;
  }

  @media screen and (max-width: $pub-xs) {
    gap: 70px;
    margin-top: 70px;
  }
}

@media screen and (max-width: $xs) {
  :deep(.public-service-links-grid-item) {
    min-height: 250px;
  }
}
</style>
